<template>
  <div class="choose-area pct100 flex-layout">
    <el-input :disabled="disabled"
              class="margin10"
              :placeholder="placeholder"
              readonly
              v-model="formatArea">
      <el-button :disabled="disabled"
                 slot="suffix"
                 type="text"
                 @click="queryArea">选择</el-button>
    </el-input>
    <app-Dpment-tree ref="areaTree"
                     :expandAll="false"
                     :showCheckbox="false"
                     dialogTitle="选择部门"
                     @saveChecked="change"></app-Dpment-tree>
  </div>
</template>

<script>
import { api } from '../api'
// import appAreaTree from '@src/components/business/app-alarm/RegionTree.vue'
import appDpmentTree from '@src/components/business/app-dpMent-tree'
export default {
  name: 'choose-area',
  model: {
    prop: 'selectDpMent',
    event: 'handleReturn'
  },
  components: {
    appDpmentTree
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    selectDpMent: {
      type: String,
      default: ''
    }
  },
  watch: {
    selectDpMent (newVal) {
      console.log(newVal)
      // this.areas = newVal.split('|');
      this.areas = newVal.split(':');
    },
    areas (newVal) {
      this.areas = newVal;
      // this.$emit('handleReturn', this.areas.join('|'));
      this.$emit('handleReturn', this.areas.join(':'));
    }
  },
  computed: {
    formatArea () {
      // return this.areas[1]
      return this.areas[0]
    }
  },
  data () {
    return {
      areas: [],
      showArea: false
    }
  },
  mounted () {
    this.areas = this.selectDpMent.split(':');
    this.$emit('handleReturn', this.areas.join(':'));
  },
  methods: {
    queryArea () {
      // this.showArea = true;
      // this.$refs['areaTree'].open(this.areas)
      this.$refs['areaTree'].openDialog(this.areas)
    },
    submit () {
      this.selectPerson = this.$refs.tree.getCheckedNodes();
      // this.showArea = false;
    },
    close () {
      // this.showArea = false;
    },
    change (val) {
      // this.areas = [val[0].id, val[0].label];
      this.areas = [val[0].label, val[0].id];
    }
  }
}
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";
.choose-person {
  z-index: 99;
  position: relative;
  .person-show {
    background-color: #262a49;
    // @include set_theme_color(background-color, dialog-main-bg-color);
    .header {
      background-color: #272b37;
    }
    .body {
      background-color: #171c28;
    }
    .footer {
      padding: 5px;
      background-color: #272b37;
    }
    .person-list {
      overflow: hidden;
      height: 200px;
    }
  }
}
</style>